<header class="home-toolbar">
  <nav
    class="home-segments"
    [attr.aria-label]="'app.components.horizontalTabs.sectionsLabel' | translate"
  >
    <a
      routerLink="/home/assignments"
      routerLinkActive="home-segments__btn--active"
      class="home-segments__btn"
      (click)="onTabClick(tabs.DUTIES)"
    >
      {{ 'app.components.ticketBoard.duties' | translate }}
      <span class="home-segments__badge">{{ assignmentsLength() }}</span>
    </a>
    <a
      routerLink="/home/courses"
      routerLinkActive="home-segments__btn--active"
      class="home-segments__btn"
      (click)="onTabClick(tabs.COURSES)"
    >
      {{ 'app.components.ticketBoard.courses' | translate }}
      <span class="home-segments__badge">{{ coursesCount() }}</span>
    </a>
  </nav>
</header>
